import React from 'react';

import CardDialog from '~/components/CardDialog';
import type { Policy, PolicySearchValues, PolicyWithClaimsData } from '~/components/Fnol/FnolAiInbox/types';
import { useCms } from '~/components/hooks/useCms';
import PolicySearchContainer from '~/components/PolicySearch';

interface PolicySearchCardProps {
  onSelectPolicy: (policyData: PolicyWithClaimsData) => void;
  onCancel: () => void;
  onTakeLossWithoutPolicy?: () => void;
  allowedSubOrgIds?: number[];
  constSearchValues?: PolicySearchValues;
}

export const PolicySearchCard: React.FC<PolicySearchCardProps> = ({
  onSelectPolicy,
  onCancel,
  onTakeLossWithoutPolicy,
  allowedSubOrgIds,
  constSearchValues,
}) => {
  const { userOrganization } = useCms();

  // Handle policy selection with claims data - matches main FNOL flow signature
  const handlePolicySelectedWithClaims = async (
    policy: Policy,
    claimValues: { date_of_loss?: string; reported_date?: string }
  ) => {
    await onSelectPolicy({
      policy,
      claimValues: claimValues || {},
    });
  };

  return (
    <CardDialog isDialog title="Search Policy" onClose={onCancel} maxWidth="lg" fullWidth>
      <div>
        <PolicySearchContainer
          onSelectPolicy={handlePolicySelectedWithClaims}
          enableSelectingRelatedClaim={true}
          choosePolicyFromRelatedClaimsText="Select this Policy"
          policyTypes={userOrganization.supported_claim_types.map((claimType) =>
            claimType.replace('_claim', '_policy')
          )}
          allowedSubOrgIds={allowedSubOrgIds}
          hideCollapsibleWrapper={true}
          constSearchValues={constSearchValues}
          returnOriginalSearchResult={true}
          onTakeLossWithoutPolicy={onTakeLossWithoutPolicy}
        />
      </div>
    </CardDialog>
  );
};
